import { Injectable } from '@angular/core';

/** Nothing to open: a published runtime has no workflow editor. */
class NoEditorWorkflowNavigation implements EditorWorkflowNavigation {
  revealWorkflowNode(): void {
    // Intentionally empty.
  }
}

/**
 * Lets the engine hand the user off to the workflow editor.
 *
 * An app running inside the editor reports workflow failures with an offer to open the node that
 * failed. Where that editor is and how it gets there is `scope:dashboard`'s business.
 */
@Injectable({ providedIn: 'root', useFactory: () => new NoEditorWorkflowNavigation() })
export abstract class EditorWorkflowNavigation {
  /** Opens `nodeId` of `workflowId` in the workflow editor, leaving the current page in place. */
  abstract revealWorkflowNode(workflowId: string, nodeId?: string): void;
}
